import CustomInput from "../CustomInput";
import { ReactComponent as Search } from 'assets/common/searchW.svg'
import CustomButton from "../CustomButton";
import { ReactComponent as Close } from 'assets/header/close.svg'
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { IAddressGoogle } from "types/address";
import { IQuote } from "types/quote";
import { ReactComponent as AddSelectOn } from 'assets/common/addSelectOn.svg'
import { ReactComponent as AddSelectOff } from 'assets/common/addSelectOff.svg'

// Google Maps 타입 정의 확장
declare global {
    interface Window {
        google: any;
    }
}

interface IHsCodeModal {
    isOpen: boolean,
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setQuoteInfo: React.Dispatch<React.SetStateAction<IQuote>>,
    addressType: string
}

const AddressModal = ({ isOpen, setIsOpen, setQuoteInfo, addressType }: IHsCodeModal) => {
    const [text, setText] = useState<string>('')
    const [list, setList] = useState<IAddressGoogle[]>([])
    const [once, setOnce] = useState<boolean>(false);
    const [type, setType] = useState<number>(0);
    const [address1, setAddress1] = useState<string>('');
    const [address2, setAddress2] = useState<string>('');

    const API_KEY = process.env.REACT_APP_GOOGLE_MAPS;

    const close = () => {
        setType(0)
        setText('')
        setAddress1('')
        setAddress2('')
        setList([])
        setIsOpen(false);
    }

    const search = async () => {
        if (!text) return toast.error("주소를 입력해주세요.");

        if (!once) {
            setOnce(true)
            // const regionCode = detectRegionCode(text);

            try {
                const res = await axios.post(
                    "https://places.googleapis.com/v1/places:searchText",
                    {
                        textQuery: text,
                        // languageCode: regionCode,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-Goog-Api-Key": API_KEY!,
                            "X-Goog-FieldMask":
                                "places.displayName,places.formattedAddress",
                        },
                    }
                );

                setList(res.data.places);
                setOnce(false)
            } catch (err) {
                console.error(err);
                toast.error("검색에 실패했습니다.");
            }
        }
    };

    // const detectRegionCode = (text: string): string => {
    //     if (/[\u3131-\uD79D]/gi.test(text)) {
    //         return "ko"; // 한글
    //     }
    //     if (/^[A-Za-z\s]+$/.test(text)) {
    //         return "en"; // 영어
    //     }
    //     if (/[\u3040-\u30ff]/.test(text)) {
    //         return "ja"; // 일본어 (히라가나/가타카나)
    //     }
    //     if (/[\u4e00-\u9fff]/.test(text)) {
    //         return "zh-CN"; // 중국어 (한자)
    //     }
    //     return "en"; // 기본값 (영어)
    // };


    const setAddress = (text: string, formattedAddress: string) => {
        setQuoteInfo((p) => ({
            ...p,
            step2: {
                ...p.step2,
                ...(addressType === 'delivery' && {
                    deliveryAddress: formattedAddress,
                    deliveryAddressDetail: text,
                }),
                ...(addressType === 'inland' && {
                    inlandAddress: formattedAddress,
                    inlandAddressDetail: text,
                }),
            },
        }));

        close();
    }

    if (!isOpen) return null;

    return (
        <div className="z-[100] fixed">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 px-4">
                <div className="bg-white shadow-lg p-6 rounded-lg w-[660px] tablet:w-96 max-h-[80vh] overflow-y-auto">
                    <div className='flex flex-col gap-6 font-semibold text-center'>
                        <div className='flex flex-col items-start gap-3'>
                            <div className="flex justify-between items-center w-full">
                                <p className='text-2xl'>주소 검색</p>
                                <Close className='cursor-pointer' onClick={() => {
                                    close();
                                }
                                } />
                            </div>
                        </div>

                        <div className="flex items-center gap-6">
                            {
                                ['주소 검색', '주소 직접입력'].map((item, idx) => (
                                    <label
                                        htmlFor={`type${idx}`}
                                        className='flex justify-between items-center gap-2 h-full cursor-pointer'
                                        key={idx}
                                    >
                                        {
                                            type === idx ?
                                                <AddSelectOn /> :
                                                <AddSelectOff />
                                        }
                                        <p className={type === idx ? 'text-black' : 'text-[#9D9EB7]'}>{item}</p>
                                        <input
                                            className="hidden accent-primary"
                                            type="checkbox"
                                            id={`type${idx}`}
                                            checked={type === idx}
                                            onChange={() => {
                                                setType(idx)
                                                setAddress1('')
                                                setAddress2('')
                                                setText('')
                                                setList([])
                                            }}
                                        />
                                    </label>
                                ))
                            }
                        </div>

                        {
                            type === 0 ?
                                <>
                                    <div className="flex justify-between gap-6">
                                        <CustomInput
                                            type="text"
                                            placeholder="도로명, 지번, 건물명 등을 입력하세요"
                                            value={text}
                                            onChange={(e) => {
                                                setText(e.target.value);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    search();
                                                }
                                            }}
                                        />
                                        <CustomButton
                                            className='bg-primary !min-w-400'
                                            Icon={Search}
                                            disabled={once}
                                            title='검색'
                                            onClick={() => search()}
                                        />
                                    </div>

                                    <p className="font-normal text-left">주소를 입력하면 아래에 자동 완성 목록이 나타납니다.</p>

                                    <div className="border border-[#9D9EB7] rounded h-96 overflow-y-auto">
                                        {
                                            (list && list.length > 0) ?
                                                list.map((item, idx) => (
                                                    <div className="flex flex-col items-start hover:bg-[#CFE5FF] p-4 border-b text-left transition-all cursor-pointer" key={idx}
                                                        onClick={() => setAddress(item.displayName.text, item.formattedAddress)}
                                                    >
                                                        <p>{item.displayName.text}</p>
                                                        <p>{item.formattedAddress}</p>
                                                    </div>
                                                ))
                                                :
                                                <div className="flex justify-center items-center h-full text-[#9D9EB7]">검색된 내용이 없습니다.</div>
                                        }
                                    </div>
                                </> :
                                <>
                                    {
                                        [
                                            { label: '주소', value: address1, set: setAddress1 },
                                            { label: '상세주소', value: address2, set: setAddress2 },
                                        ].map((item, idx) => (
                                            <div className="flex items-center gap-6" key={idx}>
                                                <p className="flex-[1] text-left">{item.label}</p>
                                                <CustomInput
                                                    className="flex-[8]"
                                                    type="text" height={15} fontSize={'sm'}
                                                    placeholder={`${item.label}를 입력해주세요`}
                                                    value={item.value}
                                                    onChange={(e) => {
                                                        item.set(e.target.value)
                                                    }}
                                                />
                                            </div>
                                        ))
                                    }

                                    <CustomButton
                                        className='self-end bg-primary !w-[180px]'
                                        disabled={address1.length === 0}
                                        title='주소입력'
                                        onClick={() => setAddress(address2, address1)}
                                    />
                                </>
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddressModal;